import { Component, OnInit } from '@angular/core';
import { DeviceInfo } from 'ngx-device-detector';
import { DeviceService } from '../../../../../client/app/device.service';

@Component({
    selector: 'app-device-info',
    templateUrl: './device-info.component.html',
    styleUrls: ['./device-info.component.scss']
})
export class DeviceInfoComponent implements OnInit {
    deviceInfo: DeviceInfo;

    constructor(private readonly deviceService: DeviceService) {}

    ngOnInit() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
    }
}
